import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { ArmyBuilderConfig, UserService } from '../../../global';
import { EntityBeforeDeleteHookFn } from '../../config';
import {
    UnitDeletionConfirmationComponent,
    UnitDeletionConfirmationData
} from '../components/unit-deletion-confirmation/unit-deletion-confirmation.component';

export function createGenericBeforeDeleteUnitHook(): EntityBeforeDeleteHookFn {
    const userService = inject(UserService);
    const config = inject(ArmyBuilderConfig);

    return async (gameId: string, entityType: string, entityId: string, entityName: string) => {
        const url = `${config.apiBaseUrl}/userData/forces/affected?gameId=${encodeURIComponent(gameId)}&entityType=${encodeURIComponent(entityType)}&entityId=${encodeURIComponent(entityId)}&entityName=${encodeURIComponent(entityName)}`;

        const affectedData: any = await firstValueFrom(userService.adminOnlyRoute('get', url));

        if (!affectedData || affectedData.affectedForcesCount === 0) {
            return null;
        }

        const modalData: UnitDeletionConfirmationData = {
            entityName: affectedData.entityName,
            affectedForcesCount: affectedData.affectedForcesCount,
            affectedUsersCount: affectedData.affectedUsersCount,
            defaultAlertMessage: affectedData.defaultAlertMessage
        };

        return {
            modalComponent: UnitDeletionConfirmationComponent,
            modalData,
            onConfirm: async (dismissData: any) => {
                const { customAlertMessage } = dismissData;
                const alertId = `alert-${entityId}-${Date.now()}`;
                const alerts = affectedData.forces.map((force: any) => ({
                    email: force.email,
                    dataType: 'forces',
                    dataId: force.forceId,
                    alert: {
                        id: alertId,
                        type: 'warning',
                        message: customAlertMessage,
                        createdAt: Date.now()
                    }
                }));

                const alertsUrl = `${config.apiBaseUrl}/userData/alerts`;
                await firstValueFrom(userService.adminOnlyRoute('post', alertsUrl, { alerts }));
            },
            onCancel: () => {
                // No action needed on cancel
            }
        };
    };
}
